import { Button, Group, Loader, Stepper, type StepperProps } from "@mantine/core"
import type { UseFormReturnType } from "@mantine/form"
import { useTranslation } from "react-i18next"
import { SuperOnly } from "../utils"

type TProps = {
  onTest?: (step: number, setStep?: (step: number) => void) => void
  onSubmit: (e: any) => void
  form: UseFormReturnType<any>
  finishLabel?: string
  pending?: boolean
} & StepperProps

export function StepsForm(props: TProps) {
  const { form, children, onSubmit, onTest, finishLabel, pending, ...stepperProps } = props
  return (
    <>
      <Stepper {...stepperProps}>{children}</Stepper>
      <FormControls
        {...props}
        form={form}
        onTest={onTest}
        pending={pending}
        onSubmit={onSubmit}
        finishLabel={finishLabel}
        steps={(children as any[]).length}
      />
    </>
  )
}

function FormControls({
  form,
  active,
  steps,
  finishLabel,
  onStepClick,
  onTest,
  onSubmit,
  pending,
}: TProps & { steps: number }) {
  const { t } = useTranslation()
  return (
    <Group pt="xl">
      {onTest && (
        <SuperOnly>
          <Button variant="light" color="cyan" onClick={() => onTest(active, onStepClick)} disabled={pending}>
            {t("Test")}
          </Button>
        </SuperOnly>
      )}
      <Button
        mr="auto"
        variant="undo"
        disabled={!form.isDirty() || pending}
        onClick={() => {
          onStepClick?.(0)
          form.reset()
        }}
      >
        {t("Reset")}
      </Button>
      {active !== 0 && (
        <Button variant="navy" onClick={() => onStepClick?.(active - 1)} disabled={pending}>
          {t("Back")}
        </Button>
      )}
      {active !== steps - 1 && (
        <Button variant="save" disabled={!form.isValid() || pending} onClick={() => onStepClick?.(active + 1)}>
          {t("Next")}
        </Button>
      )}
      {active === steps - 1 && (
        <Button
          variant="save"
          disabled={!form.isValid() || pending}
          onClick={onSubmit}
          leftSection={pending && <Loader size="xs" type="oval" color="dark" />}
        >
          {t(finishLabel || "Finish")}
        </Button>
      )}
    </Group>
  )
}
